import type IUsersRepository from '@/core/domain/users/IUsersRepository.ts'
import type PaginationRequest from '@/core/domain/pagination/PaginationRequest.ts'
import type PaginationResponse from '@/core/domain/pagination/PaginationResponse.ts'
import type { LocalUser, UserView } from '@/core/domain/users/LocalUser.ts'
import type UserSearchRequest from '@/core/domain/users/UserSearchRequest.ts'

export default class FetchAllUserUseCase {
  private readonly userRepository: IUsersRepository

  constructor(userRepository: IUsersRepository) {
    this.userRepository = userRepository
  }

  async execute(filters: UserSearchRequest, request: PaginationRequest): Promise<PaginationResponse<LocalUser & UserView>> {
    return this.userRepository.fetchAll(filters, request)
  }
}